import { useLocation } from 'react-router-dom';
import { track } from './analyticsClient.js';
import { rememberLandingPage } from './analyticsAttribution.js';
import { teamRegistrationUrl } from './teamLanding.js';
const events = {
  "/tjana-pengar-till-studenten":"class_cta_click",
  "/salja-med-klassen":"class_cta_click",
  '/tjana-pengar-till-klassresan': 'class_cta_click',
  '/klassforsaljning': 'class_cta_click',
  '/tjana-pengar-till-foreningen': 'association_cta_click',
  '/tjana-pengar-till-laget': 'laget_cta_click',
};
export function useLandingRegistration(placement) {
  const { pathname, search } = useLocation();
  const path = pathname.replace(/\/$/, '');
  const effectivePlacement = path === "/tjana-pengar-till-studenten" && placement === "inline" ? "guide-inline" : path === "/tjana-pengar-till-klassresan" && placement === "inline" ? "guide-inline" : path === "/salja-med-klassen" && placement === "inline" ? "guide-salja-inline" : placement;
  return {
    to: events[path] ? teamRegistrationUrl(search) : '/register-group',
    onClick: () => {
      if (!events[path]) return;
      rememberLandingPage(path);
      track(events[path], { placement:effectivePlacement });
    },
  };
}
